import { stepBaggageAndPersonalItemsSCTILookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatHappenedToYourBaggageAndPersonalItems && typeof data.whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
    ? data.whatHappenedToYourBaggageAndPersonalItems.toJS()
    : data.whatHappenedToYourBaggageAndPersonalItems || [];
  const baggageDelay = expensesSelected.includes('Baggage delay') ? mapToBaggageDelay(data) : [];
  const lostStolenOrDamagedItems = expensesSelected.includes('Lost, stolen or damaged items') ? mapToLostStolenOrDamaged(data) : [];
  return [...baggageDelay, ...lostStolenOrDamagedItems];
}

function mapToBaggageDelay(data) {
  if (data.infoBaggageDelayItems.length < 1) {
    return [];
  }

  const expenses = [];

  const claimCode = expenseLookup.daggageDelay.claimCode;
  data.infoBaggageDelayItems.forEach(
    (item) => {
      const expense = mapExpenseItem(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );
  return expenses;
}

function mapToLostStolenOrDamaged(data) {
  const expensesLostItemSelected = !!data.whatItemsAreYouClaimingFor && typeof data.whatItemsAreYouClaimingFor.toJS === 'function'
    ? data.whatItemsAreYouClaimingFor.toJS()
    : data.whatItemsAreYouClaimingFor || [];
  if (data.infoEssentialMedicationItems.length < 1 &&
    data.infoJewelleryOrTraditionalWatchesItems.length < 1 &&
    data.infoLaptopsTabletsOrCamerasItems.length < 1 &&
    data.infoOtherUnspecifiedItems.length < 1 &&
    data.infoSpecifiedHighValueItems.length < 1 &&
    data.infoBankCardsOrTravelDocumentsItems.length < 1 &&
    data.infoCashItems.length < 1) {
    return [];
  }
  const expenses = [];
  let claimCode = expenseLookup.essentialMedication.claimCode;

  if (expensesLostItemSelected.includes('Essential medication')) {
    claimCode = expenseLookup.essentialMedication.claimCode;
    data.infoEssentialMedicationItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Jewellery or traditional watches')) {
    claimCode = expenseLookup.jewelleryOrTraditionalWatches.claimCode;
    data.infoJewelleryOrTraditionalWatchesItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Laptops, tablets or cameras')) {
    claimCode = expenseLookup.laptopsTabletsOrCameras.claimCode;
    const claimCodeNewThePolicy = expenseLookup.laptopsTabletsOrCamerasNewThePolicy.claimCode;
    if (!claimCode || claimCode === '') {
      claimCode = claimCodeNewThePolicy;
    }
    data.infoLaptopsTabletsOrCamerasItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Other unspecified items')) {
    claimCode = expenseLookup.otherUnspecifiedTtems.claimCode;
    data.infoOtherUnspecifiedItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Specified high value items')) {
    claimCode = expenseLookup.specifiedHighValueItems.claimCode;
    data.infoSpecifiedHighValueItems.forEach(
      (item) => {
        const expensesFromItem = mapExpensesSpecifiedItem(item, data, claimCode);
        if (expensesFromItem && expensesFromItem.length > 0) {
          expenses.push(...expensesFromItem);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Bank cards or travel documents')) {
    claimCode = expenseLookup.bankCardsOrTravelDocuments.claimCode;
    data.infoBankCardsOrTravelDocumentsItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }
  if (expensesLostItemSelected.includes('Cash')) {
    claimCode = expenseLookup.cash.claimCode;
    data.infoCashItems.forEach(
      (item) => {
        const expense = mapExpenseLostStolenOrDamagedItem(item, data, claimCode);
        if (!!expense) {
          expenses.push(expense);
        }
      }
    );
  }

  return expenses;
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapExpenseLostStolenOrDamagedItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    dateOfPurchase: item.dateOfPurchase,
    depreciationType: item.depreciationType,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapExpensesSpecifiedItem(item, itemDate, claimCode) {
  if (!item || !item.currency || !Array.isArray(item.specifiedItemIds)) {
    return null;
  }

  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  const expenses = item.specifiedItemIds.map((specifiedItemId) => {
    const specifiedItem = item.specifiedItemList.find(
      (x) => x.id === specifiedItemId
    );

    if (!specifiedItem) return null;

    return {
      shortDescription: `${specifiedItem.covered}`,
      dateOfExpense: item.dateOfExpenses,
      clientCost: specifiedItem.amount,
      currency: item.currency,
      rate: null,
      requestedAmount: null,
      claimTypeCode: claimCode,
      dateOfPurchase: item.dateOfPurchase,
      claimForInsuredIds,
      claimForInsureds: selectedClaimForArray,
      depreciationType: item.depreciationType
    };
  });

  return expenses.filter((expense) => expense !== null);
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits, policyTypeCode) {
  const list = [];
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = expenseLookup.claimCodeList;
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const baggageAndPersonalItemsSelected = !!data.whatHappenedToYourBaggageAndPersonalItems && typeof data.whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
    ? data.whatHappenedToYourBaggageAndPersonalItems.toJS()
    : data.whatHappenedToYourBaggageAndPersonalItems || [];

  const damagedItemsSelected = !!data.whatItemsAreYouClaimingFor && typeof data.whatItemsAreYouClaimingFor.toJS === 'function'
    ? data.whatItemsAreYouClaimingFor.toJS()
    : data.whatItemsAreYouClaimingFor || [];

  const isDaggageDelaySelected = baggageAndPersonalItemsSelected.includes('Baggage delay');
  const isLostStolenOrDamagedSelected = baggageAndPersonalItemsSelected.includes('Lost, stolen or damaged items');
  const isEssentialMedicationSelected = damagedItemsSelected.includes('Essential medication');
  const isSpecifiedHighValueItemsSelected = damagedItemsSelected.includes('Specified high value items');
  const isBankCardsOrTravelDocumentsSelected = damagedItemsSelected.includes('Bank cards or travel documents');
  const isCashSelected = damagedItemsSelected.includes('Cash');
  const isJewelleryOrTraditionalWatchesSelected = damagedItemsSelected.includes('Jewellery or traditional watches');
  const isUnspecifiedLaptopSelected = damagedItemsSelected.includes('Laptops, tablets or cameras');
  const isOtherUnspecifiedItemsSelected = damagedItemsSelected.includes('Other unspecified items');

  const listPolicyHideParentDocuments = ['INT-COMP-AU', 'WORK-AU', 'INT-COMP-NZ', 'WORK-NZ', 'VISIT-NZ'];
  const isShowParentDocuments = !listPolicyHideParentDocuments.includes(policyTypeCode);

  const baggageAndPersonalItemsCode = expenseLookup.baggageAndPersonalItems.claimCode;
  const daggageDelayCode = expenseLookup.daggageDelay.claimCode;
  const essentialMedicationCode = expenseLookup.essentialMedication.claimCode;
  const specifiedHighValueItemsCode = expenseLookup.specifiedHighValueItems.claimCode;
  const bankCardsOrTravelDocumentsCode = expenseLookup.bankCardsOrTravelDocuments.claimCode;

  const baggageDelayExpenses = isDaggageDelaySelected ? mapToBaggageDelay(data) : [];
  const lostStolenOrDamagedExpenses = isLostStolenOrDamagedSelected ? mapToLostStolenOrDamaged(data) : [];
  const allExpenses = [...baggageDelayExpenses, ...lostStolenOrDamagedExpenses];

  if ((isDaggageDelaySelected || isEssentialMedicationSelected || isSpecifiedHighValueItemsSelected || isBankCardsOrTravelDocumentsSelected ||
    isCashSelected || isJewelleryOrTraditionalWatchesSelected || isUnspecifiedLaptopSelected || isOtherUnspecifiedItemsSelected) && claimTypes !== undefined) {
    claimTypes.forEach(
      (item) => {
        if (item.claimCode === baggageAndPersonalItemsCode && (isDaggageDelaySelected || isEssentialMedicationSelected
          || isSpecifiedHighValueItemsSelected || isJewelleryOrTraditionalWatchesSelected || isUnspecifiedLaptopSelected
          || isOtherUnspecifiedItemsSelected || ((isBankCardsOrTravelDocumentsSelected || isCashSelected) && isShowParentDocuments))) {
          const benefit = mapClaimExpensesLevelItem(item, 'Baggage and Personal Items', allExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if (item.claimCode === daggageDelayCode && isDaggageDelaySelected) {
          const benefit = mapClaimExpensesLevelItem(item, 'Baggage delay', baggageDelayExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if (item.claimCode === essentialMedicationCode && isEssentialMedicationSelected) {
          const benefit = mapClaimExpensesLevelItem(item, 'Essential medication', lostStolenOrDamagedExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if (item.claimCode === specifiedHighValueItemsCode && isSpecifiedHighValueItemsSelected) {
          const benefit = mapClaimExpensesLevelItem(item, 'Specified high value items', lostStolenOrDamagedExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
        if (item.claimCode === bankCardsOrTravelDocumentsCode && (isBankCardsOrTravelDocumentsSelected || isCashSelected)) {
          const benefit = mapClaimExpensesLevelItem(item, 'Cash, bank cards, travel documents and passports', lostStolenOrDamagedExpenses);
          if (!!benefit) {
            list.push(benefit);
          }
        }
      }
    );
  }

  return list;
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggageAndPersonalItemsSCTIDataMapper.js